import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import { Button, Heading } from '@digdir/designsystemet-react';
import { CheckmarkCircleIcon } from '@navikt/aksel-icons';
import { shallowEqual } from 'react-redux';

import { useEnergyAnalysis } from '../../../../hooks/useEnergyAnalysis';
import { useBuildingData } from '../../../../hooks/useBuildingDetails/buildingDetailsHooks';
import useSelector from '../../../../hooks/useSelector';
import { BuildingCard } from '../omBoligen/buildingCard';
import { ButtonWrapper } from '../solceller/form/components/styledComponents';

import { TiltakCard } from './components/tiltakCard';
import { AttestCard } from './components/attestCard';
import { PageHeaderWrapper, PageWrapper } from './components/styledComponents';
import { EnergiattestLoader } from './components/energiattestLoader';

const Energiattest: FC = () => {
  const { t } = useTranslation();
  const { registrationId } = useParams();

  const { energyAnalysis, energyAnalysisLoading } = useEnergyAnalysis(registrationId || '');
  const { building, buildingLoading } = useBuildingData(energyAnalysis?.registrering.energiObjektId);

  // This solution will not give same result every time you visit the URL.
  // TODO: 17947 - Fix. Tiltak should be fetched together with energyAnalysis.
  const tiltakList = useSelector((state) => state.register?.energiplan?.gjenstaendeTiltak, shallowEqual);

  if (energyAnalysisLoading || buildingLoading) {
    return <EnergiattestLoader />;
  }

  // The registration flow has two entry points, building and energiplan. The return path should be different depending on the entry point.
  const isEnergiplan = !!energyAnalysis?.registrering.soknadId;
  const returnPath = isEnergiplan ? `/energiplan/${building?.energiObjektId}` : `/`;

  return (
    <PageWrapper>
      <PageHeaderWrapper>
        <CheckmarkCircleIcon aria-hidden fontSize="3rem" />
        <Heading level={1} data-size="lg">
          {t('energiattestPage.heading')}
        </Heading>
      </PageHeaderWrapper>

      <BuildingCard building={building} />
      <AttestCard energyAnalysis={energyAnalysis} />
      <TiltakCard tiltakList={tiltakList} />

      <ButtonWrapper>
        <Button asChild variant="secondary">
          <Link to={returnPath}>{t('energiattestPage.buttons.back')}</Link>
        </Button>
      </ButtonWrapper>
    </PageWrapper>
  );
};

export default Energiattest;
